import { render, staticRenderFns } from "./ordersetting.vue?vue&type=template&id=1980ef46&scoped=true&"
import script from "./ordersetting.vue?vue&type=script&lang=js&"
export * from "./ordersetting.vue?vue&type=script&lang=js&"
import style0 from "./ordersetting.vue?vue&type=style&index=0&id=1980ef46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1980ef46",
  null
  
)

export default component.exports